import * as React from "react";

export const EstacioWeekPercentIcon = (props) => (
	<svg
		version="1.1"
		id="Camada_1"
		xmlns="http://www.w3.org/2000/svg"
		x="0px"
		y="0px"
		viewBox="0 0 300 300"
		style={{
			enableBackground: "new 0 0 300 300",
		}}
		xmlSpace="preserve"
		{...props}
	>
		<g>
			<path
				d="M73.7,127.6c29.8,0,54-24.2,54-54s-24.2-54-54-54s-54,24.2-54,54C19.7,103.4,43.9,127.6,73.7,127.6z
		 M73.7,55.6c9.9,0,18,8.1,18,18s-8.1,18-18,18s-18-8.1-18-18C55.7,63.7,63.8,55.6,73.7,55.6z M226.4,172.3c-29.8,0-54,24.2-54,54
		s24.2,54,54,54s54-24.2,54-54C280.3,196.5,256.2,172.3,226.4,172.3z M226.4,244.3c-9.9,0-18-8.1-18-18c0-9.9,8.1-18,18-18
		c9.9,0,18,8.1,18,18C244.4,236.2,236.3,244.3,226.4,244.3z M288.7,11.3c-7-7-18.4-7-25.4,0c0,0,0,0,0,0L11.3,263.2
		c-7.1,7-7.1,18.4-0.2,25.4c7,7.1,18.4,7.1,25.4,0.2c0.1-0.1,0.1-0.1,0.2-0.2L288.7,36.7C295.8,29.7,295.8,18.3,288.7,11.3
		C288.7,11.3,288.7,11.3,288.7,11.3z"
			/>
		</g>
	</svg>
);
